/* Drag&Drop mobile menu controls v1 — 2026-10-25 (rev 2)
   - B2C/B2B + language dropdown live in the menu's top bar (logo and tagline step aside) to free space.
   - B2C/B2B get plain-language labels (Bireysel / Kurumsal).
   - "Tasarımcılar" becomes a top-level row; each category's "Tüm …" link moves to the top of its list.
   Works on the shell built by dd-mobile-menu-glass-v3.js without changing that file: it only moves and
   relabels existing nodes, so that script's references stay valid. */
(function () {
  "use strict";
  var CHEVRON_DOWN = '<svg viewBox="0 0 20 20" aria-hidden="true" focusable="false"><path d="m5.5 7.75 4.5 4.5 4.5-4.5"/></svg>';
  var CHEVRON_RIGHT = '<svg viewBox="0 0 20 20" aria-hidden="true" focusable="false"><path d="m7.5 5 5 5-5 5"/></svg>';
  var PEOPLE = '<svg viewBox="0 0 24 24" aria-hidden="true" focusable="false"><circle cx="9" cy="8" r="3"/><path d="M3.5 19c.6-3.3 2.6-5 5.5-5s4.9 1.7 5.5 5"/><path d="M15.5 5.3a3 3 0 0 1 0 5.4M17.2 14.3c1.9.6 3 2.2 3.3 4.7"/></svg>';
  var COPY = {
    tr: { modes: ["Bireysel", "Kurumsal"], designers: "Tasarımcılar" },
    en: { modes: ["Personal", "Business"], designers: "Designers" },
    de: { modes: ["Privat", "Business"], designers: "Designer" },
    fr: { modes: ["Particulier", "Pro"], designers: "Créateurs" },
    es: { modes: ["Particular", "Empresa"], designers: "Diseñadores" },
    ru: { modes: ["Розница", "Бизнес"], designers: "Дизайнеры" },
    ar: { modes: ["أفراد", "شركات"], designers: "المصممون" }
  };
  var ALL_RE = /^(tüm|tümü|tümünü|all|alle|alles|tout|toute|tous|toutes|todo|toda|todos|todas|все|вся|весь|كل|جميع)(\s|$)/i;
  var uid = 0;

  function localeOf(shell) {
    var root = shell.closest("[data-ddh4-root]");
    return ((root && root.getAttribute("data-locale")) || document.documentElement.lang || "tr").toLowerCase().split("-")[0];
  }

  function enhance(shell) {
    if (!shell || shell.getAttribute("data-ddm-controls") === "1") return;
    var scroll = shell.querySelector(".ddm-scroll");
    var modeWrap = shell.querySelector(".ddm-mode-wrap");
    var lang = shell.querySelector(".ddm-language");
    if (!scroll || !modeWrap || !lang) return;
    shell.setAttribute("data-ddm-controls", "1");

    var locale = localeOf(shell);
    var t = COPY[locale] || COPY.tr;
    var prefix = locale === "tr" ? "" : "/" + locale;

    /* Controls row: B2C/B2B pill + language dropdown, placed in the top bar next to the close button. */
    var row = document.createElement("div");
    row.className = "ddm-controls";
    var drop = document.createElement("div");
    drop.className = "ddm-lang";
    drop.setAttribute("data-open", "false");
    var trigger = document.createElement("button");
    trigger.type = "button";
    trigger.className = "ddm-lang__trigger";
    trigger.setAttribute("aria-haspopup", "true");
    trigger.setAttribute("aria-expanded", "false");
    if (!lang.id) lang.id = "ddm-lang-menu-" + (++uid);
    trigger.setAttribute("aria-controls", lang.id);
    var labelNode = lang.querySelector(".ddm-section-label");
    var label = labelNode ? (labelNode.textContent || "").trim() : "";
    if (label) trigger.setAttribute("aria-label", label);

    drop.appendChild(trigger);
    drop.appendChild(lang);
    row.appendChild(modeWrap);
    row.appendChild(drop);
    var top = shell.querySelector(".ddm-top");
    var close = shell.querySelector(".ddm-close");
    if (top && close && close.parentNode === top) top.insertBefore(row, close);
    else scroll.insertBefore(row, scroll.firstChild);

    function isOpen() { return drop.getAttribute("data-open") === "true"; }
    function setOpen(open) {
      drop.setAttribute("data-open", open ? "true" : "false");
      trigger.setAttribute("aria-expanded", open ? "true" : "false");
    }
    function syncLanguage() {
      var form = lang.querySelector("form");
      drop.hidden = !form;
      if (!form) { setOpen(false); return; }
      var current = form.querySelector(".is-current,[aria-current]") || form.querySelector("button");
      var flag = current && current.querySelector(".ddh4-flag");
      var code = current && current.querySelector("strong");
      var text = code ? (code.textContent || "").trim() : "";
      if (!text) text = locale.toUpperCase();
      trigger.innerHTML = "";
      if (flag) {
        var f = document.createElement("span");
        f.className = flag.className;
        f.setAttribute("aria-hidden", "true");
        trigger.appendChild(f);
      }
      var s = document.createElement("strong");
      s.textContent = text;
      trigger.appendChild(s);
      trigger.insertAdjacentHTML("beforeend", CHEVRON_DOWN);
    }

    trigger.addEventListener("click", function (event) {
      event.preventDefault();
      setOpen(!isOpen());
    });
    shell.addEventListener("pointerdown", function (event) {
      if (isOpen() && !drop.contains(event.target)) setOpen(false);
    });
    drop.addEventListener("keydown", function (event) {
      if (event.key === "Escape" && isOpen()) {
        event.preventDefault();
        event.stopPropagation();
        setOpen(false);
        try { trigger.focus({ preventScroll: true }); } catch (e) { trigger.focus(); }
      }
    });
    lang.addEventListener("click", function (event) {
      var btn = event.target && event.target.closest ? event.target.closest("button") : null;
      if (btn) setTimeout(function () { setOpen(false); }, 140);
    });
    new MutationObserver(syncLanguage).observe(lang, { childList: true, attributes: true, attributeFilter: ["hidden"] });
    var mobile = shell.closest("[data-ddh4-mobile]") || shell.parentNode;
    if (mobile) {
      new MutationObserver(function () { if (mobile.hidden) setOpen(false); })
        .observe(mobile, { attributes: true, attributeFilter: ["hidden"] });
    }
    syncLanguage();

    /* B2C / B2B -> plain-language labels (the menu script rebuilds the links on every open). */
    var modeList = modeWrap.querySelector(".ddm-mode");
    function labelModes() {
      if (!modeList) return;
      var items = modeList.querySelectorAll(".ddm-mode__item");
      for (var i = 0; i < items.length && i < 2; i++) {
        if (items[i].getAttribute("data-ddm-label") === t.modes[i]) continue;
        items[i].textContent = t.modes[i];
        items[i].setAttribute("data-ddm-label", t.modes[i]);
        items[i].setAttribute("aria-label", t.modes[i] + " (" + (i ? "B2B" : "B2C") + ")");
      }
    }
    if (modeList) new MutationObserver(labelModes).observe(modeList, { childList: true });
    labelModes();

    /* Category list: designers as a top-level row; "Tüm …" links first in each list. */
    var tree = shell.querySelector(".ddm-tree");
    function designersRow() {
      var section = document.createElement("section");
      section.className = "ddm-group ddm-group--link";
      section.setAttribute("data-group", "designers");
      var a = document.createElement("a");
      a.className = "ddm-group__toggle ddm-group__link";
      a.href = prefix + "/pages/tasarimcilar";
      a.innerHTML = '<span class="ddm-group__icon" aria-hidden="true">' + PEOPLE + '</span><span class="ddm-group__copy"><strong></strong></span><span class="ddm-chevron" aria-hidden="true">' + CHEVRON_RIGHT + '</span>';
      a.querySelector("strong").textContent = t.designers;
      section.appendChild(a);
      return section;
    }
    function decorateTree() {
      if (!tree) return;
      var groups = tree.querySelectorAll(":scope > .ddm-group:not(.ddm-group--link)");
      if (!groups.length) return;
      if (!tree.querySelector(":scope > .ddm-group--link")) {
        var after = tree.querySelector(':scope > .ddm-group[data-group="new"]') || groups[0];
        tree.insertBefore(designersRow(), after.nextSibling);
      }
      var inners = tree.querySelectorAll(".ddm-group__panel-inner");
      for (var i = 0; i < inners.length; i++) {
        var inner = inners[i];
        var rows = inner.children;
        for (var j = 0; j < rows.length; j++) {
          var item = rows[j];
          if (item.tagName !== "A" || !item.classList.contains("ddm-subrow")) continue;
          var strong = item.querySelector("strong");
          if (strong && ALL_RE.test((strong.textContent || "").trim())) {
            item.classList.add("ddm-subrow--all");
            if (inner.firstElementChild !== item) inner.insertBefore(item, inner.firstElementChild);
            break;
          }
        }
      }
    }
    if (tree) new MutationObserver(decorateTree).observe(tree, { childList: true });
    decorateTree();
  }

  var scheduled = false;
  function scan() {
    scheduled = false;
    var shells = document.querySelectorAll("[data-ddm-shell]");
    for (var i = 0; i < shells.length; i++) enhance(shells[i]);
  }
  function schedule() {
    if (scheduled) return;
    scheduled = true;
    if (window.requestAnimationFrame) window.requestAnimationFrame(scan);
    else setTimeout(scan, 16);
  }
  function start() {
    scan();
    var target = document.querySelector("[data-ddh4-root]") || document.body || document.documentElement;
    new MutationObserver(schedule).observe(target, { childList: true, subtree: true });
  }
  if (document.readyState === "loading") document.addEventListener("DOMContentLoaded", start);
  else start();
})();
